import { AlertSubject } from "../../shared/model/alert";
import { ManualVitalsInterface } from "../../shared/model/report.model";

export function getTotalCountOfVitalsTaken(data: Partial<ManualVitalsInterface>): number {
    let count = 0;
    Object.entries(data).forEach(([key, value]) => {
        if (value === null) {
            return
        }
        if (key === AlertSubject.SystolicPressure || key === AlertSubject.SystolicPressureCamelCase) {
            count++
        }
        if (key === AlertSubject.HeartRate || key === AlertSubject.HeartRateCamelCase) {
            count++
        }
        if (key === AlertSubject.BodyTemperature || key === AlertSubject.BodyTemperatureCamelCase) {
            count++
        }
        if (key === AlertSubject.RespirationRate || key === AlertSubject.RespirationRateCamelCase) {
            count++
        }
        if (key === AlertSubject.PainLevel || key === AlertSubject.PainLevelCamelCase) {
            count++
        }
        if (key === AlertSubject.SPO2) {
            count++
        }
    })
    return count
}